import {
  REVIEW_TYPE_SYSTEM_NAMES_PA_POP,
  REVIEW_TYPE_SYSTEM_NAMES_PAYER_POP,
  REVIEW_TYPE_SYSTEM_NAMES_UR_POP,
} from '../../../../../libs/Constants';
import {
  REVIEW_TYPE_ID_PA_POP,
  REVIEW_TYPE_ID_PAYER_POP,
  REVIEW_TYPE_ID_UR_POP,
} from '../../../../../libs/envSpecificConstants';
import { getCortexReviews } from '../../../../Chart/api';
import { getReviews } from '../../../../ViewAndDo/api';

const SYSTEM_NAME_KEY = 'review_type_system_name';
const TYPE_ID_KEY = 'review_type_id';

const getLatestReviewByType = (reviews, reviewTypeKey, typeSource) =>
  reviews.find((review) => typeSource?.includes(review[reviewTypeKey]));

const constructReviewSummary = (reviews, keyType, typeSources) => ({
  latestURReview: {
    data: getLatestReviewByType(reviews, keyType, typeSources.UR),
    title: 'Latest UR Review Summary',
  },
  latestPAReview: {
    data: getLatestReviewByType(reviews, keyType, typeSources.PA),
    title: 'Latest PA Review Summary',
  },
  latestPayerReview: {
    data: getLatestReviewByType(reviews, keyType, typeSources.PAYER),
    title: 'Latest Payer Review Summary',
  },
});

export const getLatestReviews = async (entityid, admissionid, patientid) => {
  const isRRReviews = entityid.length > 4;

  const keyType = isRRReviews ? SYSTEM_NAME_KEY : TYPE_ID_KEY;

  const typeSources = isRRReviews
    ? {
        UR: REVIEW_TYPE_SYSTEM_NAMES_UR_POP,
        PA: REVIEW_TYPE_SYSTEM_NAMES_PA_POP,
        PAYER: REVIEW_TYPE_SYSTEM_NAMES_PAYER_POP,
      }
    : {
        UR: REVIEW_TYPE_ID_UR_POP,
        PA: REVIEW_TYPE_ID_PA_POP,
        PAYER: REVIEW_TYPE_ID_PAYER_POP,
      };

  const fetchReviews = isRRReviews
    ? () => getReviews(entityid, admissionid)
    : () => getCortexReviews(entityid, patientid, admissionid);

  try {
    const { reviews } = await fetchReviews();

    return constructReviewSummary(reviews, keyType, typeSources);
  } catch (e) {
    console.error(e);
    return {};
  }
};
